module.exports = __webpack_public_path__ + "img/settings.4f67cfa6.png";